import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PaymentListCrimpService {
  crimp$ = new BehaviorSubject<boolean>(true);
}
